export const content = {
  es: {
    // Hero section
    title: "Finca selvática de 64 hectáreas en Corcovado, Costa Rica",
    description: "Una oportunidad única para adquirir un paraíso natural en una de las zonas más biodiversas del planeta.",
    cta: "Descubrir Propiedad",
    
    // About section
    about: {
      title: "Acerca de la Finca",
      subtitle: "Un santuario natural en el corazón de Corcovado",
      description: "La finca se encuentra en una de las zonas más privilegiadas de Corcovado, con una biodiversidad impresionante y un entorno natural único. Este terreno de 64 hectáreas combina áreas de conservación con zonas aptas para desarrollo sostenible.",
      quote: "Corcovado es el lugar biológicamente más intenso de la Tierra.",
      quoteAuthor: "National Geographic"
    },
    
    // Property details
    details: {
      title: "Detalles de la Propiedad",
      overview: "La finca está conformada en su mayoría por terreno de montaña destinado a la conservación y cuido de la naturaleza, con un sector de tacotal de 10 hectáreas apto para agricultura y construcción.",
      features: [
        {
          title: "Conservación Natural",
          description: "Bosque tropical húmedo virgen, único en el Pacífico Mesoamericano"
        },
        {
          title: "Recursos Hídricos",
          description: "Atravesada por 3 riachuelos y colindante con el Río Claro"
        },
        {
          title: "Biodiversidad",
          description: "Hábitat de especies como jaguar, puma, chancho de monte y tapir"
        },
        {
          title: "Ubicación Privilegiada",
          description: "Colindante con el Parque Nacional Corcovado"
        }
      ],
      location: "La finca se localiza con entrada desde la calle principal, a 3 km de la Escuela de Los Planes de Drake en la península de Osa, adyacente a la Estación del Guardaparques.",
      directions: "Para ingresar a la finca, se llega a la estación del guardaparques en Los Planes. A un lado de la edificación inicia un trillo ancho; a unos 400 m se encuentra el rótulo que identifica la finca."
    },
    
    // Investment benefits
    benefits: [
      {
        title: "Paraíso Natural",
        description: "Ubicado en una de las regiones con mayor biodiversidad del planeta, esta finca ofrece una experiencia única de inmersión en la naturaleza."
      },
      {
        title: "Inversión Sostenible",
        description: "Una oportunidad para invertir en conservación mientras se disfruta de un entorno natural privilegiado con potencial para ecoturismo."
      },
      {
        title: "Desarrollo Responsable",
        description: "Posibilidad de desarrollar proyectos sostenibles en armonía con el entorno, combinando conservación y agricultura regenerativa."
      }
    ],
    
    // Gallery section
    gallery: {
      title: "Galería de Imágenes",
      subtitle: "Explora la belleza natural de esta propiedad única"
    },
    
    // Video section
    videos: {
      title: "Videos de la Propiedad",
      subtitle: "Experimenta la majestuosidad de la finca a través de estos videos"
    },
    
    // Contact section
    contact: {
      title: "Contáctanos",
      subtitle: "Estamos aquí para responder a todas tus preguntas sobre esta propiedad única",
      formTitle: "Envíanos un mensaje",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      message: "Mensaje",
      interest: "Interés principal",
      interestOptions: ["Inversión", "Conservación", "Ecoturismo", "Agricultura", "Otro"],
      submit: "Enviar mensaje",
      required: "* Campos requeridos. Nos pondremos en contacto contigo lo antes posible.",
      contactInfo: "Información de contacto",
      location: "Ubicación",
      locationDesc: "La propiedad se encuentra en Los Planes de Drake, en la Península de Osa, una de las zonas más biodiversas de Costa Rica."
    },
    
    // Call to action
    cta_section: {
      title: "¿Interesado en esta propiedad única?",
      description: "Contáctenos hoy para obtener más información o programar una visita.",
      button: "Contactar Ahora"
    },
    
    // Contact information
    contactInfo: {
      phone: "+506 8712 8720",
      phoneFormatted: "+506 8712 8720",
      phoneUrl: "tel:+50687128720",
      email: "info@flordeagarthicorcovado.com",
      emailUrl: "mailto:info@flordeagarthicorcovado.com",
      location: "Los Planes de Drake, Península de Osa, Costa Rica",
      mapUrl: "https://maps.app.goo.gl/BfLUH4ppqyfrvpN18"
    }
  },
  
  en: {
    // Hero section
    title: "64-Hectare Estate in Corcovado, Costa Rica",
    description: "A unique opportunity to acquire a natural paradise in one of the most biodiverse areas on the planet.",
    cta: "Discover Property",
    
    // About section
    about: {
      title: "About the Property",
      subtitle: "A natural sanctuary in the heart of Corcovado",
      description: "The property is located in one of the most coveted areas of Corcovado, boasting impressive biodiversity and a unique natural environment. This 64-hectare estate combines conservation areas with zones suitable for sustainable development.",
      quote: "Corcovado is the most biologically intense place on Earth.",
      quoteAuthor: "National Geographic"
    },
    
    // Property details
    details: {
      title: "Property Details",
      overview: "The estate is mainly a mountainous terrain dedicated to nature conservation, with a 10-hectare area suitable for agriculture and infrastructure development.",
      features: [
        {
          title: "Natural Conservation",
          description: "Virgin humid tropical forest, unique in the Mesoamerican Pacific"
        },
        {
          title: "Water Resources",
          description: "Crossed by 3 streams and adjacent to the Claro River"
        },
        {
          title: "Biodiversity",
          description: "Habitat for species like jaguars, pumas, wild boars, and tapirs"
        },
        {
          title: "Prime Location",
          description: "Adjacent to Corcovado National Park"
        }
      ],
      location: "The estate is located with a main street entrance, 3 km from the Escuela de Los Planes de Drake on the Osa Peninsula, adjacent to the Park Rangers' Station.",
      directions: "To enter the estate, arrive at the park rangers' station at Los Planes. Next to the building, a wide trail begins; about 400 m in, there is a sign identifying the estate."
    },
    
    // Investment benefits
    benefits: [
      {
        title: "Natural Paradise",
        description: "Located in one of the regions with the highest biodiversity on the planet, this estate offers a unique nature immersion experience."
      },
      {
        title: "Sustainable Investment",
        description: "An opportunity to invest in conservation while enjoying a privileged natural environment with ecotourism potential."
      },
      {
        title: "Responsible Development",
        description: "Possibility to develop sustainable projects in harmony with the environment, combining conservation and regenerative agriculture."
      }
    ],
    
    // Gallery section
    gallery: {
      title: "Image Gallery",
      subtitle: "Explore the natural beauty of this unique property"
    },
    
    // Video section
    videos: {
      title: "Property Videos",
      subtitle: "Experience the majesty of the estate through these videos"
    },
    
    // Contact section
    contact: {
      title: "Contact Us",
      subtitle: "We are here to answer all your questions about this unique property",
      formTitle: "Send us a message",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      interest: "Main interest",
      interestOptions: ["Investment", "Conservation", "Ecotourism", "Agriculture", "Other"],
      submit: "Send message",
      required: "* Required fields. We will get back to you as soon as possible.",
      contactInfo: "Contact information",
      location: "Location",
      locationDesc: "The property is located in Los Planes de Drake, on the Osa Peninsula, one of the most biodiverse areas in Costa Rica."
    },
    
    // Call to action
    cta_section: {
      title: "Interested in this unique property?",
      description: "Contact us today for more information or to schedule a visit.",
      button: "Contact Now"
    },
    
    // Contact information
    contactInfo: {
      phone: "+506 8712 8720",
      phoneFormatted: "+506 8712 8720",
      phoneUrl: "tel:+50687128720",
      email: "info@flordeagarthicorcovado.com",
      emailUrl: "mailto:info@flordeagarthicorcovado.com",
      location: "Los Planes de Drake, Osa Peninsula, Costa Rica",
      mapUrl: "https://maps.app.goo.gl/BfLUH4ppqyfrvpN18"
    }
  }
}; 